var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDistanceLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0893 20.8452L21.0893 22.2862L3.70996 22.2862L3.70996 20.8452L21.0893 20.8452Z",
    fill: "#272D3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3985 3.31378C14.7147 3.31378 16.2756 4.48556 17.2559 5.94706C18.2164 7.37901 18.6171 9.07753 18.6968 10.223L18.6985 10.2511V22.2862H17.3951V10.3159C17.327 9.37983 16.9884 7.96679 16.2088 6.8045C15.4439 5.66449 14.2533 4.75472 12.3985 4.75472C10.539 4.75472 9.26588 5.6702 8.40589 6.8317C7.54344 7.9966 7.10561 9.40492 6.96751 10.3431V22.2862H5.66406V10.223L5.6717 10.1686C5.83088 9.02503 6.34735 7.33769 7.3969 5.91986C8.46311 4.47975 10.0871 3.31378 12.3985 3.31378Z",
    fill: "#272D3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8746 14.1208V15.5617H8.92285V14.1208H15.8746Z",
    fill: "#272D3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4809 9.31769V10.7586L6.31543 10.7586V9.31769L18.4809 9.31769Z",
    fill: "#272D3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistanceLocation);
export default __webpack_public_path__ + "static/media/distance_location.638cbb3f3f65b486bb3d4d0ca7141ce5.svg";
export { ForwardRef as ReactComponent };